module.exports = __webpack_public_path__ + "img/airbase-stage_6.5.27815160.jpg";